exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Table__table___1QfTK {\n  border-spacing: 0;\n}\n\n.Table__table___1QfTK thead td {\n  border-bottom: 1px solid #dfe5ec;\n  font-weight: bold;\n  padding: 8px;\n}\n\n.Table__table___1QfTK tbody tr {\n  cursor: pointer;\n  -webkit-transition: .08s;\n  transition: .08s;\n}\n\n.Table__table___1QfTK tbody tr:nth-child(even) {\n  background: #f9fafb;\n}\n\n.Table__table___1QfTK tbody tr:hover {\n  background: #f0f3f6;\n}\n\n.Table__table___1QfTK tbody td {\n  font-size: 14px;\n  padding: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"table": "Table__table___1QfTK"
};